import React from 'react';
import {compose, withState} from 'recompose';
import './styles.scss';
import {Link} from 'react-router-dom';

const Index = ({text, openConditions, setOpenConditions}) => {
  return (
    <React.Fragment>
      <div className="banner">
        <p className="banner__text">
          {text}
        </p>
        <a rel="noopener noreferrer" target="_blank" className="button button--light"
           href={require('./resources/rules.docx')}>
          Условия программы
        </a>
      </div>
    </React.Fragment>
  );
};

export const BottomBanner = ({text}) => {
  return (
    <div className="banner">
      <p className="banner__text">
        {text}
      </p>
      <div className="hero__button-container">
        <Link to="/recommend" className="button button--dark">
          Рекомендую!
        </Link>
        <Link to="/apply" className="button button--light">
          Хочу к вам
        </Link>
      </div>
    </div>
  );
};

const enhance = compose(
  withState('openConditions', 'setOpenConditions', false),
);

export default enhance(Index);
